var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "span",
    [
      _c(
        "div",
        { staticClass: "d-flex flex-row-reverse" },
        [
          _c(
            "v-btn",
            {
              staticStyle: { cursor: "pointer" },
              attrs: { icon: "" },
              on: { click: _vm.updateSearch },
            },
            [
              _c(
                "v-icon",
                {
                  attrs: {
                    "b-tooltip.hover": "",
                    title: "Request content from the server",
                    color: "primary",
                  },
                },
                [_vm._v("mdi-refresh")]
              ),
            ],
            1
          ),
          _c(
            "v-btn",
            {
              staticStyle: { cursor: "pointer" },
              attrs: { icon: "" },
              on: { click: _vm.logout },
            },
            [
              _c(
                "v-icon",
                {
                  attrs: {
                    "b-tooltip.hover": "",
                    title: "Return to login page",
                    color: "red",
                  },
                },
                [_vm._v("mdi-logout")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("h3", [_vm._v("Scans Options")]),
      _c(
        "v-container",
        { staticClass: "bg-surface-variant" },
        [
          _c(
            "v-row",
            { attrs: { "no-gutters": "" } },
            [
              _c(
                "v-col",
                { attrs: { cols: "12", sm: "8" } },
                [
                  _c(
                    "v-sheet",
                    [
                      _c(
                        "v-radio-group",
                        {
                          attrs: { row: "", inline: "" },
                          model: {
                            value: _vm.scanDays,
                            callback: function ($$v) {
                              _vm.scanDays = $$v
                            },
                            expression: "scanDays",
                          },
                        },
                        [
                          _c("v-radio", {
                            attrs: {
                              label: "Today's",
                              value: 0,
                              "tooltip.hover": "",
                              title: "Show today's scans",
                            },
                            on: { click: _vm.updateSearch },
                          }),
                          _c("v-radio", {
                            attrs: {
                              label: "30 Days",
                              value: 30,
                              "tooltip.hover": "",
                              title: "Show 30 days cumulative scans",
                            },
                            on: { click: _vm.updateSearch },
                          }),
                          _c("v-radio", {
                            attrs: {
                              label: "60 Days",
                              value: 60,
                              "tooltip.hover": "",
                              title: "Show 60 days cumulative scans",
                            },
                            on: { click: _vm.updateSearch },
                          }),
                          _c("v-radio", {
                            attrs: {
                              label: "90 Days",
                              value: 90,
                              "tooltip.hover": "",
                              title: "Show 90 days cumulative scans",
                            },
                            on: { click: _vm.updateSearch },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("v-spacer"),
      _c(
        "div",
        { staticClass: "d-flex flex-column justify-content-between" },
        [
          _c("v-data-table", {
            attrs: {
              headers: _vm.headers,
              "item-key": "id",
              items: _vm.executions,
              "items-per-page": 5,
              loading: _vm.loading,
              "show-sort-icons": true,
              "show-select": "",
            },
            scopedSlots: _vm._u([
              {
                key: "no-data",
                fn: function () {
                  return [_vm._v(" No data. Try relaxing the scan options. ")]
                },
                proxy: true,
              },
            ]),
            model: {
              value: _vm.selectedExecutions,
              callback: function ($$v) {
                _vm.selectedExecutions = $$v
              },
              expression: "selectedExecutions",
            },
          }),
          _c(
            "v-btn",
            {
              staticClass: "card-outter",
              attrs: { block: "" },
              on: { click: _vm.loadResults },
            },
            [
              _vm._v(" Load Selected "),
              _c("v-icon", { staticClass: "pl-2" }, [
                _vm._v(" mdi-file-download"),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }